// function isExpressionValid() {
// 	const $form = jQuery('.frm-show-form')
//
// 	const formRadioCount = $form.find('input[type=radio]').length
// 	const formSelectCount = $form.find('select').length
// 	const formVerifyCount = $form.find('input.frm_verify').length
// 	const formTextCount = $form.find('input[type=text]').length
// 	const formEmailCount = $form.find('input[type=email]').length
//
// 	return formRadioCount > 1 && formSelectCount === 0
// 		&& (formVerifyCount === 1 && formTextCount === 1 || formVerifyCount === 0 && formTextCount === 0)
// 		&& formEmailCount === 0
// }
//
// function hideNextButton() {
// 	if (isExpressionValid()) {
// 		jQuery('.frm_button_submit').hide()
// 	}
// }
//
// // hide form next button after page loaded
// jQuery(document).on('ready', function () {
// 	hideNextButton()
// })
//
// // event on form label click
// jQuery('.formidable').on('click', '.frm_radio > label', function () {
// 	if (isExpressionValid()) {
// 		setTimeout(function () {
// 			jQuery('.frm_button_submit').trigger('click')
// 		}, 1)
// 	}
// });
//
// // event on form page change
// jQuery(document).on('frmPageChanged', function (event, form, response) {
// 	hideNextButton()
// });

/*Form script */
if (jQuery('.frm-show-form').find('input[type=radio]').length > 1 &&
	jQuery('.frm-show-form').find('select').length == 0 &&
	(jQuery('.frm-show-form').find('input.frm_verify').length === 1 &&
		jQuery('.frm-show-form').find('input[type=text]').length === 1 ||
		jQuery('.frm-show-form').find('input.frm_verify').length === 0 &&
		jQuery('.frm-show-form').find('input[type=text]').length === 0) &&
	jQuery('.frm-show-form').find('input[type=email]').length == 0) {
	jQuery('.frm_button_submit').hide()
}

jQuery('.formidable').on('click', '.frm_radio > label', function () {
	console.log(jQuery('.frm-show-form').find('input[type=text]').length === 1)

	if (jQuery('.frm-show-form').find('input[type=radio]').length > 1 &&
		jQuery('.frm-show-form').find('select').length == 0 &&
		(jQuery('.frm-show-form').find('input.frm_verify').length === 1 &&
			jQuery('.frm-show-form').find('input[type=text]').length === 1 ||
			jQuery('.frm-show-form').find('input.frm_verify').length === 0 &&
			jQuery('.frm-show-form').find('input[type=text]').length === 0) &&
		jQuery('.frm-show-form').find('input[type=email]').length == 0) {

		setTimeout(function(){jQuery('.frm_button_submit').trigger('click');
			console.log('trigger')},1)
	}
});

jQuery(document).on('frmPageChanged', function (event, form, response) {
	console.log(13)
	let finalStepSubmitButton = jQuery('.frm_button_submit.frm_final_submit');
	if(finalStepSubmitButton.is(':visible')) {
		(function() {
			let xtfcu =jQuery('[id^="field_xxtrustedformcerturl"]').attr('name'),
				xtfpu = jQuery('[id^="field_xxtrustedformpingurl"]').attr('name');

			console.log(xtfcu);
			console.log(xtfpu);

			if(window.trustedForm !== undefined) {
				jQuery(`[name='${xtfcu}']`).val(jQuery('[name=xxTrustedFormCertUrl]').val());
				jQuery(`[name='${xtfpu}']`).val(`${window.trustedForm.pingUrl}`);
			} else {
				var tf = document.createElement('script');
				tf.type = 'text/javascript'; tf.async = true;
				tf.src = ("https:" == document.location.protocol ? 'https' : 'http') + `://api.trustedform.com/trustedform.js?field=${xtfcu}&ping_field=${xtfpu}&l=` + new Date().getTime() + Math.random();

				var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(tf, s);
			}


		})();
	}
	if (jQuery('.frm-show-form').find('input[type=radio]').length > 1 &&
		jQuery('.frm-show-form').find('select').length == 0 &&
		(jQuery('.frm-show-form').find('input.frm_verify').length === 1 &&
			jQuery('.frm-show-form').find('input[type=text]').length === 1 ||
			jQuery('.frm-show-form').find('input.frm_verify').length === 0 &&
			jQuery('.frm-show-form').find('input[type=text]').length === 0) &&
		jQuery('.frm-show-form').find('input[type=email]').length == 0
	) {
		jQuery('.frm_button_submit').hide()
	}

});